module.exports = __webpack_public_path__ + "img/atl-spotify.4558b358.jpg";